import { render, staticRenderFns } from "./ShopScreenTopBar.vue?vue&type=template&id=3b8fda4f&scoped=true"
import script from "./ShopScreenTopBar.vue?vue&type=script&lang=js"
export * from "./ShopScreenTopBar.vue?vue&type=script&lang=js"
import style0 from "./ShopScreenTopBar.vue?vue&type=style&index=0&id=3b8fda4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8fda4f",
  null
  
)

export default component.exports